/**
 * Payment processing fee constants
 */
export const STRIPE_PROCESSING_FEE_PERCENTAGE = 0.017;
export const STRIPE_FIXED_FEE = 0.3;
export const AU_GST_RATE = 0.1;
export const SESSION_COMPLETED_DELAY = 1000; // 1 second delay before proceeding
export const SESSION_CHECK_INTERVAL = 5000; // 5 seconds interval to check session status
export const SESSION_PRE_CHECKOUT_DELAY = 500; // short delay upon preparing to checkout
export const INVOICE_GENERATION_DELAY = 1000; // 1 second delay before creating invoice
export const INVOICE_GENERATION_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
};
export const INVOICE_STATUS = {
    DRAFT: {
        id: "DRAFT",
        label: "Draft",
        color: "inherit",
    },
    AWAITING_PAYMENT: {
        id: "AWAITING_PAYMENT",
        label: "Awaiting payment",
        color: "primary",
    },
    PAID: {
        id: "PAID",
        label: "Paid",
        color: "secondary",
    },
    VOID: {
        id: "VOID",
        label: "Void",
        color: "error",
    },
    REFUNDED: {
        // deprecated, refunded invoices should retain their current status
        id: "REFUNDED",
        label: "Refunded",
        color: "inherit",
    },
    PENDING: {
        id: "PENDING",
        label: "Pending",
        color: "error",
    },
};
export const INVOICE_PAYMENT_OPTION = {
    ONLINE: {
        id: 'ONLINE',
        label: 'Online'
    },
    INVOICE: {
        id: 'INVOICE',
        label: 'Invoice'
    }
};
export const INVOICE_CREATION_SOURCE = {
    BOOKING_PAGE: 'BOOKING_PAGE',
    ADD_ON_CHARGE: 'ADD_ON_CHARGE',
};
export const INVOICE_STATUS_ACTION = {
    MARK_AS_PAID: 'MARK_AS_PAID',
    MARK_AS_AWAITING_PAYMENT: 'MARK_AS_AWAITING_PAYMENT',
    REFUNDED: 'REFUNDED',
    VOID: 'VOID'
};
export const TAX_MODES = {
    EXCLUSIVE: {
        id: 'EXCLUSIVE',
        label: 'Tax exclusive',
        abbreviation: 'EXC'
    },
    INCLUSIVE: {
        id: 'INCLUSIVE',
        label: 'Tax inclusive',
        abbreviation: 'INC'
    },
    NO_TAX: {
        id: 'NO_TAX',
        label: 'No tax'
    }
};
export const PAYMENT_STATUSES = Object.freeze({
    AWAITING_PAYMENT: {
        id: "AWAITING_PAYMENT",
        label: "Awaiting payment",
    },
    PAID: {
        id: "PAID",
        label: "Paid",
    },
    REFUNDED: {
        id: "REFUNDED",
        label: "Refunded",
    },
    VOID: {
        id: "VOID",
        label: "Void",
    },
});
//# sourceMappingURL=payment.js.map